import { useEffect, useState } from "react";
import { Header } from "../../common/Header";
import { OrderCard } from "./OrderCard";
import { OrderCardSkeleton } from "./OrderCard";
import { OrderFilters } from "./OrderFilters";
import { ApiOrder } from "@nusrif/types";
import { getOrdersList } from "@nusrif/services";
import { useNavigate } from "react-router";

export const MyOrdersPage = () => {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState<string>("all");
  const [orders, setOrders] = useState<ApiOrder[]>([]);
  const [loadingOrders, setLoadingOrders] = useState<boolean>(true);

  // Fetch orders data from API
  useEffect(() => {
    const fetchOrders = async () => {
      setLoadingOrders(true);
      try {
        const response = await getOrdersList();
        setOrders(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoadingOrders(false);
      }
    };
    fetchOrders();
  }, []);

  const filterOptions = [
    { value: "all", label: "All Orders" },
    { value: "delivered", label: "Delivered" },
    { value: "shipped", label: "Shipped" },
    { value: "processing", label: "Processing" },
    { value: "cancelled", label: "Cancelled" },
  ];
  
  const filteredOrders =
    selectedFilter === "all"
      ? orders
      : orders.filter((order) => order.status === selectedFilter);

  const handleTrackOrder = (orderId: string) => {
    console.log("Track order:", orderId);
    // Navigate to order tracking page
  };
  const handleReorder = (orderId: string) => {
    console.log("Reorder:", orderId);
    // Add items to cart and navigate to cart
  };
  const handleViewDetails = (orderId: string) => {
    console.log("View order details:", orderId);
    navigate(`/profile/my-orders/${orderId}`);
  };
  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Header */}
      <Header title="My Orders" showBackButton={true} showCartButton={false} />

      {/* Main Content */}
      {loadingOrders && (
        <div className="pt-20 px-5 space-y-4">
          {[...Array(3)].map((_, i) => (
            <OrderCardSkeleton key={i} />
          ))}
        </div>
      )}

      {!loadingOrders && (
        <div className="pt-20 px-5 space-y-6">
          {/* Filters */}
          <OrderFilters
            options={filterOptions}
            selectedFilter={selectedFilter}
            onFilterChange={setSelectedFilter}
          />
          {/* Orders List */}
          <div className="space-y-4">
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <OrderCard
                  key={order.id}
                  order={order.storeOrder}
                  onTrackOrder={handleTrackOrder}
                  onReorder={handleReorder}
                  onViewDetails={handleViewDetails}
                  id={order.id}
                  orderId={order.orderId}
                />
              ))
            ) : (
              <div className="text-center py-16">
                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-12 h-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-black mb-2">
                  No Orders Found
                </h3>
                <p className="text-gray-600">
                  {selectedFilter === "all"
                    ? "You haven't placed any orders yet."
                    : `No ${selectedFilter} orders found.`}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
